import { FlightStatusForm } from '@com-delta-idp/mnx-capability-flight-status-ui';

export const EMPTY_FORM_STRUCTURE: Pick<
  FlightStatusForm,
  'action' | 'originList' | 'destinationList' | 'cities' | 'searchModal'
> = {
  action: { label: '' },
  originList: [],
  destinationList: [],
  cities: {
    originCode: '',
    originName: '',
    originRegion: '',
    destinationCode: '',
    destinationName: '',
    destinationRegion: ''
  },
  searchModal: { sections: [] }
};

export const FLIGHT_STATUS_SMART_CONSTANTS = {
  // Component IDs
  IDS: {
    AIRPORT_SEARCH: 'flight-status-airport-search',
    TABS: 'flight-status-tabs',
    FLIGHT_STATUS: 'flightstatus',
    ERROR_BANNER: 'flight-status-error-banner'
  },

  // Labels and Titles
  LABELS: {
    DESTINATION: 'Destination',
    ORIGIN: 'Origin',
    SEARCH_BY_DATE: 'Search By Date',
    FLIGHT_NUMBER: 'Flight Number',
    FROM: 'From',
    TO: 'To',
    FROM_AIRPORT: 'From Airport',
    TO_AIRPORT: 'To Airport',
    SELECT_DATE: 'Select date'
  },

  // Placeholders
  PLACEHOLDERS: {
    SEARCH_AIRPORTS: 'Search airports...',
    FLIGHT_NUMBER_EXAMPLE: 'ex. 1049'
  },

  // Error Messages
  ERROR_MESSAGES: {
    PREDICTIVE_CITIES_ERROR: 'Flight Status: Error fetching predictive cities',
    AEM_CONTENT_UNAVAILABLE:
      "We're sorry, there was a problem. Please try again later.",
    PREDICTIVE_CITIES_NO_RESULTS:
      "We're sorry, there was a problem with your search. Go to Flight Status and try searching again"
  },

  // Floating Label Text
  FLOATING_LABELS: {
    SEARCH_AIRPORTS: 'Search airports...'
  },

  // UI Text
  UI_TEXT: {
    SELECT_AIRPORT: 'Select Airport'
  },

  // HTML Elements and Selectors
  SELECTORS: {
    INPUT: 'input',
    CLOSE_BUTTON:
      'idp-airport-dropdown-modal button[aria-label="Close"], idp-airport-dropdown-modal .close-header-button'
  },

  // Events
  EVENTS: {
    INPUT: 'input'
  },

  // Configuration Values
  CONFIG: {
    SEARCH_MENU_TYPE: 'transparent',
    FLIGHT_NUMBER_PATTERN: '^\\d{1,4}$',
    MAX_FLIGHT_NUMBER_LENGTH: 4,
    DATE_FORMAT: 'YYYY-MM-DD'
  }
} as const;

export const enum CommonConstants {
  TIMEOUT = 120000
}
export const enum HEADER_FEATURES {
  FLIGHT_STATUS = 'FLIGHT_STATUS'
}
